<template lang="pug">
  div
    p.mb-3.label.basic600--text.text-uppercase {{ $t('state.label') }}
    v-select.mt-3(v-model="address_data.state" background-color="basic200" height="40" :placeholder="$t('state.placeholder')" :items="states" item-text="name" item-value="id" outlined dense :rules="rules.not_empty_select" :loading="isLoading" @change="fetchCities(address_data.state, false)")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('city.label') }}
    v-select.mt-3(v-model="address_data.city" background-color="basic200" height="40" :placeholder="$t('city.placeholder')" :items="cities" item-text="name" item-value="id" outlined dense :rules="rules.not_empty_select" :loading="isLoading" @change="fetchSuburbs(address_data.city, false)")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('suburb.label') }}
    v-select.mt-3(v-model="address_data.suburb" background-color="basic200" height="40" :placeholder="$t('suburb.placeholder')" :items="suburbs" item-text="name" item-value="id" outlined dense :rules="rules.not_empty_select" :loading="isLoading" @change="fetchAreas(address_data.suburb, false)")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('area.label') }}
    v-select.mt-3(v-model="address_data.area" background-color="basic200" height="40" :placeholder="$t('area.placeholder')" :items="areas" item-text="area" outlined dense :rules="rules.not_empty_select" return-object :loading="isLoading" @change="setShippingAddress(address_data.area)")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('address_1.label') }}
    v-text-field(v-model="address.address_1" background-color="basic200" height="40" :placeholder="$t('address_1.placeholder')" outlined dense :rules="rules.not_empty")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('address_2.label') }}
    v-text-field(v-model="address.address_2" background-color="basic200" height="40" :placeholder="$t('address_2.placeholder')" outlined dense)
    p.mb-3.label.basic600--text.text-uppercase {{ $t('postcode.label') }}
    v-text-field(v-model="address.postcode" background-color="basic200" height="40" :placeholder="$t('postcode.placeholder')" outlined dense :rules="rules.not_empty" :loading="isLoading")
    p.mb-3.label.basic600--text.text-uppercase {{ $t('country.label') }}
    v-text-field(v-model="address.country" background-color="basic200" height="40" :placeholder="$t('country.placeholder')" outlined dense :rules="rules.not_empty" :loading="isLoading")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddressInputsId',
  props: ['parentAddress'],
  data: () => ({
    address_data: {},
    states: [],
    cities: [],
    suburbs: [],
    areas: [],
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      not_empty_select: [v => !!v || 'This field is required']
    }
  }),
  computed: {
    address: {
      get () {
        return this.parentAddress
      },
      set (newValue) {
        this.$emit('update:parentAddress', newValue)
      }
    }
  },
  watch: {
    address: {
      immediate: true,
      handler (val) {
        if (val.extra_data) {
          this.setAddressData(val.extra_data)
        } else {
          this.fetchStates()
        }
      }
    }
  },
  methods:  {
    ...mapActions([
      'showMessage'
    ]),
    fetchStates () {
      this.isLoading = true
      this.$axios.get('/addresses_idn/states')
        .then(resp => {
          this.states = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchCities (id, setData) {
      this.isLoading = true
      this.address_data = { state: id }
      this.cities = []
      this.suburbs = []
      this.areas = []
      if (!setData) {
        this.clearAddress()
      }
      this.$axios.get(`/addresses_idn/cities?state_id=${id}`)
        .then(resp => {
          this.cities = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchSuburbs (id, setData) {
      this.isLoading = true
      delete this.address_data.suburb
      delete this.address_data.area
      this.suburbs = []
      this.areas = []
      if (!setData) {
        this.clearAddress()
      }
      this.$axios.get(`/addresses_idn/suburbs?city_id=${id}`)
        .then(resp => {
          this.suburbs = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchAreas (id, setData) {
      this.isLoading = true
      delete this.address_data.area
      this.areas = []
      if (!setData) {
        this.clearAddress()
      }
      this.$axios.get(`/addresses_idn/areas?suburb_id=${id}`)
        .then(resp => {
          this.areas = resp.data
          if (setData) {
            this.address_data.area = this.areas.find(f => f.extra_data.area_id === this.parentAddress.extra_data.area_id)
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    setShippingAddress (data) {
      data.phone = this.address.phone
      data.address_1 = this.address.address_1
      data.address_2 = this.address.address_2
      this.address = data
    },
    async setAddressData (data) {
      await this.fetchStates()
      if (data.state_id) {
        this.address_data.state = data.state_id
        await this.fetchCities(data.state_id, true)
      }
      if (data.city_id) {
        this.address_data.city = data.city_id
        await this.fetchSuburbs(data.city_id, true)
      }
      if (data.suburb_id) {
        this.address_data.suburb = data.suburb_id
        await this.fetchAreas(data.suburb_id, true)
      }
    },
    clearAddress () {
      let data = {
        phone: this.address.phone
      }
      if (this.address.address_1) {
        data.address_1 = this.address.address_1
      }
      if (this.address.address_2) {
        data.address_2 = this.address.address_2
      }
      this.address = data
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "suburb": {
      "label": "Suburb",
      "placeholder": "Please select"
    },
    "area": {
      "label": "Area",
      "placeholder": "Please select"
    },
    "city": {
      "label": "City",
      "placeholder": "Please select"
    },
    "state": {
      "label": "State",
      "placeholder": "Please select"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
    "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999,"
    },
    "address_2": {
      "label": "RT/RW",
      "placeholder": "RT.14/RW.6"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "suburb": {
      "label": "Kecamatan",
      "placeholder": "Silahkan pilih"
    },
    "area": {
      "label": "Kelurahan",
      "placeholder": "Silahkan pilih"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Silahkan pilih"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "Silahkan pilih"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>